// Listens for custom form exports finishing, off the back of the PushEventService poll. The export
// is rendered by a Lambda after the request returns, which publishes CUSTOM_FORM_EXPORT_READY with
// the URL to download the finished file once it lands.
//
//   CustomFormsDownloaderService.subscribe($scope);
app.service("CustomFormsDownloaderService", [
	"PUSH_EVENTS",
	function (PUSH_EVENTS) {
		/**
		 * Wires a view up to custom form export-ready events for the life of its scope.
		 *
		 * @param scope the view's scope; the listener is removed when it is destroyed
		 */
		function subscribe(scope, spec) {
			// Watch the whole push-event stream and grab only the export-ready events.
			scope.$on(PUSH_EVENTS.ANY, function (e, pushEvent) {
				if (!pushEvent || pushEvent.type !== "CUSTOM_FORM_EXPORT_READY") {
					return;
				}
				const payload = pushEvent.data || {};
				if (payload.downloadUrl) {
					spec.csvReady(payload.downloadUrl);
				}
			});
		}

		const service = {
			subscribe: subscribe,
		};

		return service;
	},
]);
